import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource, addOnInvalidateHandler, invalidateResource } from "kea-resource";

import { Guia } from "./guia";
const controller = rpcController("RecoleccionDomicilio");

export const RecoleccionDomicilio = cacheResource({
        /**Marca como recolecada a domicilio una guia */
        RecolectarDomicilioGuia: async (model: models.RecoleccionDomicilioModel): Promise<void> => await controller('RecolectarDomicilioGuia', {}, model),
}, {

}, {
        RecolectarDomicilioGuia: true
});

addOnInvalidateHandler(RecoleccionDomicilio, () => {
        invalidateResource(Guia);
} );


// WEBPACK FOOTER //
// ./app/resources/items/recolecciondomicilio.tsx